import React from 'react';
import { TextBlock } from 'bench-internal-theme';
import styled from 'styled-components';
import ConnectionsContainer from './ConnectionsContainer';

const AccountsLayout = styled.div`
  display: grid;
  gap: 16px;
  padding: 24px 32px;
`;

const AccountsPage = () => (
  <AccountsLayout>
    <TextBlock styleType="title">Accounts</TextBlock>
    <ConnectionsContainer />
  </AccountsLayout>
);

export default AccountsPage;
